<template>
  <div>
    <div v-for="record in companies" :key="record.company.id">
      <div class="target-report-company" @click="record.showChildren = !record.showChildren" v-if="!$auth.hasRole('COMPANY_ADMIN')">
        <v-icon>{{ record.showChildren ? 'expand_less' : 'expand_more' }}</v-icon>
        <span>{{ record.company.name }}</span>
      </div>
      <table class="datatable table table-crud elevation-1" v-show="record.showChildren">
        <thead>
          <tr>
            <th>{{ $t('targetsReport.period') }}</th>
            <th>{{ $t('targetsReport.defined') }}</th>
            <th>{{ $t('targetsReport.used') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in record.items"
            :key="`${item.year}/${item.month}`"
          >
            <td>{{ `${item.year}/${item.month}` }}</td>
            <td>{{ record.company.targets.length }}</td>
            <td>{{ item.targetUsage.length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TargetsReport from '@/models/TargetsReport'

export default {
  data: () => ({
    companies: null
  }),
  created () {
    const isCompanyAdmin = this.$auth.hasRole('COMPANY_ADMIN')
    let opts

    // @TODO: This is hotfix, should be removed after backend gets fixed
    if (isCompanyAdmin) {
      opts = { companyIds: [this.$auth.getUser().company.id] }
    } else {
      opts = { companyIds: [] }

      this.$auth.getUser().companyGroups.forEach(group => {
        group.companies.forEach(company => {
          opts.companyIds.push(company.id)
        })
      })
    }

    TargetsReport
      .getList(opts)
      .then(result => {
        let companyMap = result
          .reduce((companies, item) => {
            item.companyRecordingReports.forEach(report => {
              if (!companies[report.company.id]) {
                companies[report.company.id] = {
                  company: report.company,
                  items: [],
                  showChildren: isCompanyAdmin
                }
              }

              companies[report.company.id].items.push({
                year: item.year,
                month: item.month,
                targetUsage: report.usages
              })
            })

            return companies
          }, {})

        this.companies = Object.keys(companyMap)
          .map(key => companyMap[key])
          .sort((a, b) => a.company.name.localeCompare(b.company.name))
      })
  }
}
</script>

<style>
.target-report-company {
  padding: 5px;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// TargetsReport.vue?27b151b1